class addOvatBillRuleCtrl {
    constructor($scope, httpRequest, $location, formvalidateApi) {
        $scope.add = {}
        $scope.add.validStatus = 1
        $scope.addOvatRule = function addOvatRule() {
            const ret = formvalidateApi.run()
            if (ret) {
                httpRequest.post_addOvatBillRule($scope.add, '销售拆合规则添加成功').then(() => {
                    console.log($scope.add)
                    $location.path('/system/settingcenter/ovatBillRule/list').replace()
                })
            }
        }
        $scope.cancle = function cancle() {
            $location.path('/system/settingcenter/ovatBillRule/list').replace()
        }


        $scope.validateRules = {

            ruleCode: [
                {
                    erromsg: '数字或字母组合,最长10位',
                    condition(value) {
                        // 规则
                        const regex = /^[A-Za-z0-9]+$/
                        const result = regex.test(value) && String(value).length < 11
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
            ruleName: [
                {
                    erromsg: '规则名称最长20位',
                    condition(value) {
                        // 规则

                        const result = String(value).length < 21
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
            ruleMark: [
                {
                    erromsg: '规则描述最长100位',
                    condition(value) {
                        // 规则


                        const result = String(value).length < 101
                        // true 标示显示 errmsg  false 标示验证通过
                        return !result
                    },
                },
            ],
        }
    }
}
addOvatBillRuleCtrl.$inject = ['$scope', 'httpRequest', '$location', 'formvalidateApi']
export default addOvatBillRuleCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/ovatBillRule/addOvatBillRuleCtrl.js